seedWebApp.controller('OrderDetailCtrl', ['$scope', '$rootScope', '$uibModalInstance', '$uibModal', '$window', '$document', '$timeout', 'StoreService', 'TranslationService', 'ToastService', 'DocService', 'WorkflowService', 'CompanySettingService', 'orderID', 'contactID', 'cartOrder', 'openTab',
    function OrderDetailCtrl($scope, $rootScope, $uibModalInstance, $uibModal, $window, $document, $timeout, StoreService, TranslationService, ToastService, DocService, WorkflowService, CompanySettingService, orderID, contactID, cartOrder, openTab) {        
        $scope.translation = TranslationService.getActiveTranslation();
        $scope.orderID = orderID;
        $scope.contactID = contactID;
        $scope.showDetailed = true;
        $scope.cartOrder = cartOrder;
        $scope.openTab = openTab;
        $scope.LoggedCompanyID = $rootScope.LoggedCompanyID;

        //console.log('rootScope');
        //console.log($rootScope.LoggedCompanyID);

        //QuantityMode x DateMode        
        var user = CompanySettingService.getLoggedUser();        
        $scope.user = user;

        $scope.orderMode = 'SUMMARY';
        $scope.orderMode = 'ITEMS';
        $scope.NEW_QUOTE = 'NEW_QUOTE';

        $scope.recalcTotals = function (order) {
            console.log('DETAIL.recalcTotals');
            StoreService.recalcTotals(order);
        };

        //CRIAR PEDIDO OU EDITAR
        $scope.selectContact = !contactID;
        if (orderID) {
            $scope.item = {};
            $scope.selectContact = false;
        }
        else {
            if ($scope.cartOrder) {
                $scope.item = $scope.cartOrder;
            }
            else {
                $scope.item = {
                    ContactID: contactID,
                    StatusID: WorkflowService.getStatusNewQuote(),
                    ReservationDate: new Date(),
                    Details: [],
                    TotalHPs: 0,
                    TotalPrice: 0,
                    OrderID: $scope.NEW_QUOTE,
                };
            }            
            $scope.item.isInserting = true;            
            $scope.item.DateMode = 'BEST'; //AO INSERIR, MELHOR DATA
            //$scope.item.DateMode = 'ByMonth';

            //if ($scope.cartProduct) {
            //    $scope.recalcTotals($scope.item);
            //    //$scope.addLine($scope.item);
            //}
            //else {
                if (!$scope.cartOrder) {
                    $scope.addLine($scope.item);
                }
            //}
        }

        $scope.openDocsAndFiles = function (item) {
            $scope.openFiles(item);
            $scope.openDocs(item)
        };

        

        $scope.cancel = function () {
            $uibModalInstance.dismiss($scope.item.ExpiredJustification);
        };

        $scope.refreshDetails = function () {
            console.log('refreshDetails');
            StoreService.resetCache();
            $scope.getOrderDetails();
            $scope.getPermissions();
        };
        
        $scope.doRefresh = function () {
            $scope.refreshDetails();
            $scope.onSelectEvents($scope.item);
        };

        $scope.getOrderDetails = function (openTab) {
            $scope.loading = true;
            StoreService.getOrderDetails($scope.orderID).then(function (response) {
                $scope.loading = false;
                $scope.item = response.data;
                if (!$scope.item) {
                    $uibModalInstance.dismiss();
                }
                $scope.item.loaded = true;
                $scope.recalcTotals($scope.item);
                $scope.info = {
                    CreateUserID: $scope.item.CreateUserID,
                    CreateDate: $scope.item.CreateDate,
                    CancelUserID: $scope.item.CancelUserID,
                    CancelDate: $scope.item.CancelDate
                };

                //VERIFICA SE DEVE SELECIONAR TAB
                if (openTab) {                    
                    if (openTab == 'docs') {
                        console.log('SELECTING DOCUMENTS');
                        $scope.selectedIndex = 1;
                        $scope.openDocsAndFiles($scope.item);
                    }
                }
            }, function () {
                    $scope.loading = false;
            })
        };

        $scope.getPermissions = function () {
            StoreService.getPermissions("QUOTES").then(function (response) {
                console.log('PERMS');
                //console.log(response.data)
                $scope.perms = response.data.reduce(
                    function (perms, p) {
                        if (p.ObjectName == 'Quotes.EditQuote') {
                            perms.EditQuote = p.AllowViewExec;
                        }
                        if (p.ObjectName == 'Quotes.AddQuote') {
                            perms.AddQuote = p.AllowViewExec;
                        }
                        return perms;
                    }, {}
                );
                console.log($scope.perms);
            }, function () {
                console.log('ERRO PERMISSIONS');
            })
        };
        
        if ($scope.orderID) {
            $scope.getOrderDetails($scope.openTab);
        }
        $scope.getPermissions();

        $scope.getMonthQtd = function (detail, yearMonth) {
            var det = detail.Months.find(function (d) {
                return d.YearMonth == yearMonth;
            });
            if (det) {
                return det.Quantity;
            } else {
                return 0;
            }
        };

        //PEGAR DE WORKFLOWAPI
        $scope.canEdit = function (item) {            
            return WorkflowService.canEditOrder(item);
        };

        $scope.isJustificationNeeded = function (item) {
            return WorkflowService.isJustificationNeeded(item);
        };

        $scope.startEditing = function (item) {
            if ($scope.canEdit(item)) {
                item.isEditing = true;
                item.recalcAutomatic = false;
            }

        };

        $scope.discardEditing = function (item) {
            item.isEditing = false;
            $scope.doRefresh();
        };

        $scope.isInserting = function (item) {
            if (item.OrderID == $scope.NEW_QUOTE) {
                return true;
            }
            return false;
        };

        $scope.isEditingOrInserting = function (order) {
            return order.isEditing || order.isInserting;
        };
       

        $scope.setStatus = function (order, statusID) {
            order.OldStatusID = order.StatusID;
            order.StatusID = statusID;
            for (var i = 0; i < order.Details.length; i++) {
                var detail = order.Details[i];
                if (detail.StatusID == order.OldStatusID) {
                    detail.OldStatusID = detail.StatusID;
                    detail.StatusID = statusID;
                }
            }
        };

        $scope.openOrderConfirmModal = function (order) {
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/orderConfirmModal.html',
                controller: 'OrderConfirmModalController',
                size: 'md',
                resolve: {
                    order: function () {
                        return order;
                    }
                }
            });
            return modalInstance;
        };

        $scope.trySaveOrder = function (order, isDraft) {
            order.saveError = null;
            if (StoreService.ValidateOrder(order)) {
                //MUDA PARA DRAFT
                if (isDraft) {
                    $scope.setStatus(order, 'DRAFT');
                }

                /*
                if (order.isEditing) {
                    //SALVA DIRETO
                    $scope.saveOrder(order);
                }
                else {
                */
                var modal = $scope.openOrderConfirmModal(order);
                modal.result.then(function () {
                    console.log('order CONFIRMED');
                    //$scope.broadcastOrderUpdated($scope.item.OrderID);
                    $scope.saveOrder(order);
                });                
            }
        };



        $scope.invalidateAllocations = function (order) {
            for (var i = 0; i < order.Details.length; i++) {
                var detail = order.Details[i];
                detail.lastLoaded = null;
                detail.Allocs = null;
            }
        };

        $scope.saveOrder = function (order) {
            $scope.saving = true;
            order.saveError = null;
            order.Warnings = [];
            //console.log('salvando....');
            //console.log(order);

            var toastID = ToastService.createToast('Salvando pedido...', '', 0, 'wait');
            StoreService.saveOrder(order).then(
                function (result) {
                    StoreService.resetCache();
                    $scope.saving = false;

                    //Somente se novo pedido....
                    if (!order.OrderID || $scope.isInserting(order)) {
                        order.OrderID = result.data.OrderID;
                    }                    

                    //console.log('SAVE ORDER');
                    //console.log(result.data);
                    order.Warnings = result.data.Warnings;

                    //JRM: EM CASO DE WARNINGS, NAO SAIR DA TELA!
                    if (order.Warnings.length <= 0) {
                        order.error = false;
                        ToastService.updateToast(toastID, 'Pedido ' + order.OrderID + ' foi salvo!', '', 4000, 'success');
                        $uibModalInstance.close(result.data);                        
                        order.isEditing = false;
                        order.isInserting = false;                        
                    }
                    else {
                        StoreService.resetCache();
                        $scope.invalidateAllocations(order);
                        ToastService.updateToast(toastID, 'Erros ao salvar!', '', 4000, 'error');
                    }                    
                },
                function (error) {
                    $scope.saving = false;
                    //order.error = true;
                    $scope.saving = false;
                    order.saveError = error.data;

                    console.log('saveOrder error: ');
                    console.log(error);
                    console.log('saveOrder error.data: ');
                    console.log(error.data);

                    //var errorMsg = error.data.Message;
                    //var errorExc = error.data.ExceptionMessage;                    
                    ToastService.updateToast(toastID, 'Erro ao salvar!', '', 4000, 'error');
                }
            );
        };

        //$scope.isExpired = function (order) {
        //    var today = new Date();
        //    if (order.ExpirationDate <= today) {
        //        return true;
        //    }
        //    return false;
        //};

        //$scope.getExpiredClass = function (expDate) {
        //    return AllocService.getExpiredClass(expDate);
        //};

        $scope.showExtract = true;
        $scope.toggleExtract = function () {
            console.log('toggleExtracr');
            $scope.showExtract = !$scope.showExtract;
            $scope.selIndex = -1;
        };

        $scope.getMainFlex = function (orderMode) {
            if (orderMode == 'SUMMARY') {
                return 100;
            }
            else {
                return 65;
            }
        };

        $scope.broadcastOrderUpdated = function (orderID) {
            console.log('broadcastOrderUpdated');
            $rootScope.$broadcast('onOrderUpdated', orderID);
        };


        $scope.canRenovateExpired = function (order) {            
            return WorkflowService.canRenovateExpired(order);            
        };

        $scope.canShowExpirationDate = function (item) {
            return WorkflowService.canShowExpirationDate(item);
        };

        $scope.requestRenovate = function (order) {
            order.RenovateStatusID = null;
            $scope.showRequestRenovate(order);
        };

        $scope.acceptRenovate = function (order) {            
            $scope.showRequestRenovate(order);
        };

        
        $scope.recalcOrder = function (order) {
            var toastID = ToastService.createToast('Recalculando...', '', 4000, 'wait');
            StoreService.recalcOrder(order.OrderID).then(function (response) {
                //order.ExpiredJustification = response;
                ToastService.removeToast(toastID);
                $scope.refreshDetails();
            });
        }

        $scope.onSelectEvents = function (order) {
            $scope.orderEvents = [{ EVENTS: 'EVENTS' }];
            StoreService.getOrderEvents(order.OrderID).then(
                function (response) {
                    $scope.orderEvents = response.data;
                }
            )
        };

        $scope.changeStatus = function (order, details, statusID) {
            console.log('changeStatus ' + statusID);
            //console.log(details);
            //JRM: DESABILITADO
            //ctrl.selectAll(details, true);
            //var modalInstance = AllocService.changeStatusModal(order, details, statusID);
            //modalInstance.result.then(function (newStatusID) {
            //    if (newStatusID) {
            //        //console.log('SALVAR NEWSTATUSID ' + newStatusID);
            //        //ctrl.toggleSelectMode(details, false);
            //        $scope.refreshDetails();
            //    }
            //});
        };

        $scope.clearErrors = function (order) {
            console.log('clearErrors');
            StoreService.clearErrors(order);
        };

        $scope.openFiles = function (order) {            
            order.error = null;
            var toastID = ToastService.createToast('Carregando arquivos...', '', 0, 'wait');
            $scope.loading = true;
            DocService.getOrderFiles(order.OrderID).then(function (response) {
                $scope.loading = false;
                order.Files = response.data;
                ToastService.removeToast(toastID);
            },
                function (err) {
                    $scope.loading = false;
                    //console.log('Error');
                    //console.log(err);
                    order.error = err;
                    var errMsg = '';
                    if (err.data && err.data.ExceptionMessage) {
                        errMsg = err.data.ExceptionMessage;
                    }
                    if (errMsg == 'OrderWithoutContractNumber') {
                        errMsg = $scope.translation.OrderWithoutContractNumber;
                    }
                    order.loadingError = errMsg;
                    ToastService.updateToast(toastID, 'Erro!', errMsg, 5000, 'error');
                }
            );
        };

        $scope.openDocs = function (order) {
            order.error = null;
            var toastID = ToastService.createToast('Carregando docs...', '', 0, 'wait');
            $scope.loading = true;
            DocService.getOrderDocs(order.OrderID).then(function (response) {
                $scope.loading = false;
                order.Docs = response.data;
                ToastService.removeToast(toastID);
            },
                function (err) {
                    $scope.loading = false;
                    order.error = err;
                    ToastService.updateToast(toastID, 'Erro!', $scope.getErrorMessage(err), 2000, 'error');
                });
        };

        $scope.getErrorMessage = function (err) {
            //order.error = err;
            var errMsg = '';
            if (err.data && err.data.ExceptionMessage) {
                errMsg = err.data.ExceptionMessage;
            }
            return errMsg;
        };

        $scope.onSelectEvents = function (order) {
            console.log('orderEvents');

            $scope.orderEvents = [{ EVENTS: 'EVENTS' }];
            StoreService.getOrderEvents(order.OrderID).then(
                function (response) {
                    $scope.orderEvents = response.data;
                }
            )
        };


        $scope.AdjustSize = function () {
            var innerHeight = Math.max(0, window.innerHeight);
            //console.log('AdjustSize ' + innerHeight);
            var header = 200;
            //header = 160;
            var h1 = getHeight('headerLine1');
            var h2 = getHeight('headerLine2');
            var height = innerHeight - header - h1 - h2;

            //console.log('AdjustSize ' + height);
            setSize('orderItems', height);
        };

        function setSize(name, height) {
            if (document.getElementById(name)) {
                document.getElementById(name).style.height = height + 'px';
            }
        }

        function getHeight(name) {
            if (document.getElementById(name)) {
                var height = document.getElementById(name).offsetHeight;
                return height;
            }
            return 0;
        }

        $window.onresize = function (event) {
            $scope.AdjustSize();
        };

        $document.ready(function () {
            //console.log('READY');
            $timeout(function () {
                $scope.AdjustSize();
            });

        });


        $scope.changeOrder = function () {
            console.log('changeOrder');
            /*
            var sel = [];
            $scope.prefs.items.forEach(function (item) {
                if (item.selected) {
                    sel.push(item);
                }
            })
            */

            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/changeOrderModal.html',
                controller: 'ChangeOrderModalController',
                size: 'lg',
                resolve: {
                    item: function () {
                        return $scope.item;
                    }
                }
            });
            modalInstance.result.then(function (status) {
                console.log('order changed');

                $scope.broadcastOrderUpdated($scope.item.OrderID);

                //$scope.$broadcast('refreshServiceGrid');

                //$rootScope.$broadcast('onOrderUpdated', orderID);

                //$scope.clearSelected();
                //$scope.doRefresh();
            });
        };

        $scope.canInsertOrder = function (item) {
            //JRM: SOMENTE SE FOR USERROLEID = ADMIN

            return true;

            /*
            if ($scope.LoggedCompanyID == 'GenesisAraupel') {
                return false;
            }
            else {
                return true;
            } 
            */
        };

        $scope.tryAcceptOrder = function (order, isAccept) {
            console.log('tryAcceptOrder');

            order.isAccept = isAccept;
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/orderAcceptModal.html',
                controller: 'OrderAcceptModalController',
                size: 'lg',
                resolve: {
                    order: function () {
                        return order;
                    }
                }
            });
            modalInstance.result.then(function (status) {
                //console.log('order ACCEPTED');
                var toastID = ToastService.createToast('Aceite enviado', '', 8000, 'wait');
                StoreService.acceptOrder(order).then(
                    function (response) {                        
                        if (response) {
                            console.log('tryAccept.response');

                            order.AcceptStatusID = response.data.StatusID;
                            order.AccceptStatusMessage = response.data.StatusMessage;
                            order.sit_portal = response.data.sit_portal;
                            order.btnLink.sit_portal = response.data.sit_portal;

                            //Novo status da cotaçao
                            
                            $scope.item.StatusID = response.data.QuoteStatusID;
                        }
                        ToastService.updateToast(toastID, 'Ok', '', 2000, 'success');
                    },
                    function (err) {
                        //$scope.loadingPrices = false;
                        //console.log('Erros recalc prices');
                        //console.log(err);
                        var errMsg = '';
                        if (err.data && err.data.ExceptionMessage) {
                            errMsg = err.data.ExceptionMessage;
                        }                        
                        ToastService.updateToast(toastID, 'Erro accept', errMsg, 16000, 'error');
                    }
                );
                //$scope.broadcastOrderUpdated($scope.item.OrderID);
                //$scope.$broadcast('refreshServiceGrid');
            });
        };

        $scope.toggleQuote = function (orderID) {
            if ($scope.quote) {
                $scope.quote = null;
                return;
            }
            $scope.loadingQuote = true;
            StoreService.getOrderDetails(orderID).then(function (response) {
                $scope.loadingQuote = false;
                $scope.quote = response.data;
                if (!$scope.quote) {
                    ToastService.createToast('Cotação não encontrada', orderID, 0, 'error');
                }
            }, function () {
                $scope.loadingQuote = false;
            })
        };

        $scope.openLinkedOrder = function (link, orderID) {
            //if ($scope.linkedOrder) {
            //    $scope.linkedOrder = null;
            //    return;
            //}
            console.log('openLinkedOrder');
            $scope.loadingLinked = true;
            StoreService.getOrderDetails(orderID).then(function (response) {
                $scope.loadingLinked = false;
                $scope.linkedOrder = response.data;
                $scope.linkedOrder.btnLink = link;
                $scope.recalcTotals($scope.linkedOrder);
                if (!$scope.linkedOrder) {
                    ToastService.createToast('Pedido não encontrado', orderID, 0, 'error');
                }
            }, function () {
                $scope.loadingLinked = false;
            })
        };

        $scope.isQuote = function (order) {
            return StoreService.isQuote(order);
        };

        $scope.isQuoteEditing = function (order) {
            return $scope.isQuote(order) && !$scope.isInserting(order)
        };

        $scope.verifyOrders = function (order) {
            $scope.loadingQuoteOrders = true;
            StoreService.getQuoteOrders(order.OrderID).then(function (response) {
                $scope.loadingQuoteOrders = false;
                $scope.quoteOrders = response.data;
                $scope.mergeQuotes(order, $scope.quoteOrders);
                if (!$scope.quoteOrders) {
                    ToastService.createToast('Pedidos para a cotação não encontrados', orderID, 0, 'error');
                }
            }, function () {
                $scope.loadingQuoteOrders = false;
            })
        };

        $scope.mergeQuotes = function (order, quotes) {
            console.log('mergeQuotes');
            for (var i in order.Details)
            {
                var detail = order.Details[i];
                detail.verified = true;
                detail.quoteOrders = [];
                detail.qtSupplied = 0;
                for (var q in quotes) {
                    var quote = quotes[q];
                    var sameArrival = false;
                    if (!detail.PointID) {
                        sameArrival = true;
                    }                    
                    if (quote.ArrivalPointID == detail.PointID) {
                        sameArrival = true;
                    }

                    //if (quote.PointID) {
                    //    sameArrival = quote.PointID == 
                    //}
                    if (quote.SkuID == detail.SkuID && sameArrival) {
                        detail.quoteOrders.push(quote);
                        detail.qtSupplied += quote.Quantity;
                    }
                }                
            }
        };

        $scope.tryCancelOrder = function (order) {
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/orderCancelModal.html',
                controller: 'OrderCancelModalController',
                size: 'md',
                resolve: {
                    order: function () {
                        return order;
                    }
                }
            });
            modalInstance.result.then(function (reason) {
                console.log('CANCEL ORDER');
                StoreService.cancelOrder(orderID, reason).then(
                    function (response) {
                        if (response) {
                            order.StatusID = response.data.StatusID;
                            $scope.broadcastOrderUpdated(order.OrderID);

                            $uibModalInstance.close(order);
                        }
                        ToastService.createToast('Cancelado', '', 2000, 'success');
                    },
                    function (err) {
                        var errMsg = '';
                        if (err.data && err.data.ExceptionMessage) {
                            errMsg = err.data.ExceptionMessage;
                        }
                        ToastService.createToast('Erro', errMsg, 16000, 'error');
                    }
                );
            });
        };

        $scope.tryCompleteQuote = function (order) {
            var info = {
                    Title: 'Confirma Concluir',
                    Message: 'Concluir a cotação ' + order.OrderID + '?',
            };
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/Shared/confirmModal.html',
                controller: 'ConfirmModalController',
                size: 'md',
                resolve: {
                    info: function () {
                        return info;
                    }
                }
            });
            modalInstance.result.then(function (reason) {
                console.log('COMPLETE ORDER: ' + reason);
                StoreService.completeQuote(orderID, reason).then(
                    function (response) {
                        if (response) {
                            order.StatusID = response.data.StatusID;
                            $scope.broadcastOrderUpdated(order.OrderID);
                            $uibModalInstance.close(order);
                        }
                        ToastService.createToast('Cotação conpleta', '', 2000, 'success');
                    },
                    function (err) {
                        var errMsg = '';
                        if (err.data && err.data.ExceptionMessage) {
                            errMsg = err.data.ExceptionMessage;
                        }
                        ToastService.createToast('Erro', errMsg, 16000, 'error');
                    }
                );
            });
        };

        $scope.isFinished = function (order) {
            return order.StatusID == '90_CANCELED' || order.StatusID == '05_QUOTE_COMPLETED';
        };

        $scope.isAcceptedOrRejected = function (order) {
            return StoreService.isAcceptedOrRejected(order);
            /*
            if (!order) {
                return false;
            }
           return  order.sit_portal == 5 || order.sit_portal == 2 || order.sit_portal == 6 || order.sit_portal == 3;
           */
        };

        $scope.getSitPortalClass = function (sitPortal, statusID) {
            return StoreService.getSitPortalClass(sitPortal, statusID);
        };

        $scope.exportToExcel = function (order) {
            ToastService.createToast('Exporting...', '', 4000, 'wait');
            var details = order.Details.map(function (d) {
                var m = {
                    PO_Order: order.OrderID,
                    PO_Date: order.ReservationDate,
                    Status: $scope.translation['Status_' + order.StatusID],
                    Customer: order.ContactID,
                    Arrival_Point: d.PointID + ' ' + d.PointName,
                    Line: d.SeqID,
                    SkuNumber: d.SkuID,
                    SkuName: d.SkuName,
                    Item: d.MaterialID,
                    Drawing: d.DrawingID,
                    Size: d.MatThickness + ' x ' + d.MatWidth + ' x ' + d.MatLength,
                    QtBoxes: d.QtBoxes,
                    Quantity: d.Quantity,
                    UOM: d.UnitID,
                    Cost: d.UnitPrice,
                    UN: d.PriceUnitID,
                    Amount: d.PriceAmount,
                };                
                return m;
            });
            
            var fileName = 'Quote-' + order.OrderID + '.xlsx';
            alasql('SELECT * INTO XLSX("' + fileName + '", {header:true}) FROM ?', [details]);
        };

        $scope.isPreSale = function (item) {
            return item.StatusID == '10_PRE_SALE';
        };

        $scope.recreateDocuments = function (order) {
            console.log('recreate documents ' + order.Files.length);
            order.error = null;
            var toastID = ToastService.createToast('Recreating docs...', '', 0, 'wait');
            $scope.loading = true;
            DocService.recreateOrderDocs(order.OrderID, order.Files).then(function (response) {
                $scope.loading = false;
                order.Docs = response.data;
                ToastService.removeToast(toastID);
            },
                function (err) {
                    $scope.loading = false;
                    //order.error = err;
                    ToastService.updateToast(toastID, 'Erro!', $scope.getErrorMessage(err), 2000, 'error');
                });
        };

    }]
);

